import React from 'react'

import FormLogin from '../../components/Login/FormLogin'

import '../styles/main.css'

function Main() {

    return (

        <main className='--main'>

            <div className='--content-main--login'>

                <div className='--box-main--login'>

                    <div className='--col-main--login'></div>

                    <div className='--col-main--login'>

                        <div className='--col-main--login-center'>
                        
                            <h1>Ingresa a tu cuenta</h1>
                            <p>¡Hola! Accede y encuentra el trabajo que buscas</p>

                            <div className='--line'></div>

                            <FormLogin/>
                        
                        </div>

                    </div>

                </div>

            </div>

        </main>

    )

}

export default Main